<template>
	<div class="all-wrap">
		<!-- 微信分享卡片(标题=报价名，描述=客户名+报价，首图=客户 logo) -->
		<ShareMeta :title="shareTitle" :description="shareDesc" :image="brandLogo" />

		<!-- 留言按钮 -->
		<Comment class="commentWrap" />
		<!-- 置顶组件 -->
		<gotop></gotop>
		<!-- 左侧悬浮板块导航 -->
		<SectionNav active="budget" />

		<!-- 顶部 banner 区(站内框架,高度紧凑) -->
		<div class="videolist-banner">
			<Headernew />
			<div class="bannertop-title">
				<div>报价详情</div>
				<div>——后天科技·项目报价</div>
			</div>
		</div>

		<!-- 主体 -->
		<div class="app-container">
			<BackButton v-if="isVip" @click="goList" />

			<LoadingBlock v-if="loading" />

			<template v-else>

			<!-- 版块标签：点击滚动跳转 -->
			<div class="section-tabs" v-if="detail">
				<button class="section-tab" @click="scrollToSection('sec-info')">基本信息</button>
				<button class="section-tab" v-if="detail.pdf_url" @click="scrollToSection('sec-pdf')">报价PDF</button>
			</div>

			<div v-if="detail" class="detail-card" id="sec-info">
				<div class="detail-title"><i class="iconfont icon-add"></i> {{ detail.main }}</div>

				<!-- 通用字段：有值才显示 -->
				<div class="field" v-if="detail.keys_name"><span class="label">标签</span><span class="value">{{ detail.keys_name }}</span></div>
				<div class="field" v-if="detail.created_at"><span class="label">创建时间</span><span class="value">{{ detail.created_at }}</span></div>

				<!-- 操作按钮：查看报价(新窗口打开 PDF) / 查看方案 / 查看作品 -->
				<div class="detail-actions">
					<button v-if="detail.pdf_url && isVip" class="btn-link" @click="openPdfUrl">
						<font-awesome-icon icon="fa-solid fa-file-invoice-dollar" /> 查看报价
					</button>
					<button v-if="detail.html_url && isVip" class="btn-link" @click="goScheme(detail.id)">
						<font-awesome-icon icon="fa-solid fa-file-lines" /> 查看方案
					</button>
					<button v-if="hasWork && isVip" class="btn-link" @click="goWork(detail.id)">
						<font-awesome-icon icon="fa-solid fa-film" /> 查看作品
					</button>
				</div>
			</div>
			<div v-else class="empty-state"><i class="iconfont icon-dengdai"></i><p>{{ loadError || '未找到该报价' }}</p></div>

			<!-- 报价 PDF -->
			<div class="section-block" v-if="detail && detail.pdf_url" id="sec-pdf">
				<div class="section-title">报价PDF</div>
				<!-- 微信内核不支持 iframe 预览 PDF，用 PDF.js canvas 渲染 -->
				<PdfViewer :src="detail.pdf_url" />
			</div>

			</template>
		</div>

		<Footernew />
	</div>
</template>

<script>
import Headernew from '@/components/Headernew.vue'
import Footernew from '@/components/Footernew.vue'
import Comment from '@/components/comment.vue'
import gotop from '@/components/gotop.vue'
import SectionNav from '@/components/SectionNav.vue'
import BackButton from '@/components/BackButton.vue'
import LoadingBlock from '@/components/LoadingBlock.vue'
import ShareMeta from '@/components/ShareMeta.vue'
import PdfViewer from '@/components/PdfViewer.vue'

export default {
	name: 'budgetDetail',
	components: { Headernew, Footernew, Comment, gotop, SectionNav, PdfViewer, BackButton, LoadingBlock, ShareMeta },
	data() {
		return { detail: null, loadError: '', loading: false, brandName: '', brandLogo: '' }
	},
	created() {
		this.load()
	},
	computed: {
		// 当前客户 id：优先取路径参数(从列表页带过来)，其次取详情接口返回
		brandId() {
			return this.$route.query.brand_id || (this.detail && this.detail.brand_id) || ''
		},
		// 微信分享标题/描述
		shareTitle() { return (this.detail && this.detail.main) || '后天科技 · 项目方案' },
		shareDesc() { return (this.brandName ? this.brandName + '的报价' : '项目报价') + ' · 后天科技' },
		// 是否有作品内容(视频/图片/外链/描述)：决定是否显示"查看作品"
		hasWork() {
			const d = this.detail
			if (!d) return false
			return !!(d.video_url || d.image_url || d.link_url || d.content)
		},
		// 是否 VIP：与 Headernew 一致，取缓存 usermessage.adminid == 1
		isVip() {
			try {
				const m = localStorage.getItem('usermessage')
				if (!m) return false
				return JSON.parse(m).adminid == 1
			} catch (e) {
				return false
			}
		},
	},
	methods: {
		load() {
			this.loading = true
			this.$axios.get(this.$api + '/getWorksCaseById/' + this.$route.query.id)
				.then(res => {
					const body = res.data || {}
					if (body.success && body.result) {
						this.detail = body.result
						this.loadError = ''
						this.loadBrand()
					} else {
						// 接口以 success:false 返回(如"相关方案已过期")，把 message 提示给用户
						this.detail = null
						this.loadError = body.message || ''
					}
				})
				.catch(err => {
					console.log(err)
					this.detail = null
					this.loadError = '加载失败，请稍后重试'
				})
				.finally(() => { this.loading = false })
		},
		// 拉取当前客户(取名称做分享描述、logo 做分享缩略图)
		loadBrand() {
			if (!this.brandId) return
			this.$axios.get(this.$api + '/getBrand', {
				params: { page: 1, limit: 1000 }
			}).then(res => {
				const list = (res.data.result && res.data.result.data) || []
				const cur = list.find(b => String(b.id) === String(this.brandId))
				if (cur) {
					this.brandName = cur.name
					this.brandLogo = cur.logo_url || ''
				}
			}).catch(err => console.log(err))
		},
		// 跨页跳转同样带上客户 id
		goScheme(id) {
			const query = { id }
			if (this.brandId) query.brand_id = this.brandId
			this.$router.push({ path: '/schemeDetail', query })
		},
		goWork(id) {
			const query = { id }
			if (this.brandId) query.brand_id = this.brandId
			this.$router.push({ path: '/workDetail', query })
		},
		// 查看报价：新窗口打开报价 PDF
		openPdfUrl() {
			if (this.detail && this.detail.pdf_url) window.open(this.detail.pdf_url, '_blank')
		},
		// 全部报价：回到该客户的报价时间轴；无 brand_id 时回列表页
		goList() {
			const bid = this.brandId
			if (bid) {
				this.$router.push({ path: '/brandProposal', query: { brand_id: bid, tab: 'budget' } })
			} else {
				this.$router.push({ path: '/projectProposal', query: { tab: 'budget' } })
			}
		},
		scrollToSection(id) {
			const el = document.getElementById(id)
			if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
		},
	},
}
</script>

<style scoped>
.videolist-banner { width: 100%; height: 300px; background-image: url(https://lubanhui1.oss-cn-beijing.aliyuncs.com/htkj/imgs/mediabanner.jpg); background-size: 100% 100%; position: relative; }
.bannertop-title { width: 100%; position: absolute; left: 0; top: 45%; }
.bannertop-title div:nth-of-type(1) { width: 80%; margin: 0 auto; font-size: 38px; color: #fff; font-weight: bold; }
.bannertop-title div:nth-of-type(2) { width: 48%; margin: 14px auto 0; font-size: 18px; color: #fff; text-align: right; letter-spacing: 2px; }

.app-container { max-width: 900px; margin: 0 auto; padding: 2rem 1.5rem 4rem; text-align: left; }

.detail-card { box-sizing: border-box; max-width: 1100px; margin: 0 auto; padding: 1rem 1.5rem; background: #fff; border-radius: 14px; border: 1px solid #eef2f6; box-shadow: 0 4px 12px rgba(0,0,0,.04); }
.detail-card .field { display: flex; padding: .6rem 0; border-bottom: 1px solid #f1f5f9; }
.detail-card .field:last-child { border-bottom: none; }
.detail-card .field .label { width: 90px; font-weight: 500; color: #64748b; flex-shrink: 0; font-size: .9rem; }
.detail-card .field .value { flex: 1; color: #0a2540; font-size: .95rem; word-break: break-word; }
.detail-title { font-size: 1.3rem; font-weight: 600; color: #0a2540; margin-bottom: 1rem; display: flex; align-items: center; gap: .5rem; }
.detail-title i { color: #2563eb; }
.value a { color: #2563eb; text-decoration: underline; word-break: break-all; }

/* 版块标签条 */
.section-tabs { max-width: 1100px; margin: .5rem auto 1rem; display: flex; flex-wrap: wrap; gap: .5rem; }
.section-tab { background: #f1f5f9; color: #475569; border: 1px solid #e2e8f0; padding: .35rem .9rem; border-radius: 20px; font-size: .85rem; cursor: pointer; transition: all .15s; }
.section-tab:hover { background: #dbeafe; color: #2563eb; border-color: #2563eb; }
.detail-card, .section-block, .rel-card { scroll-margin-top: 90px; }

/* 分版块 */
.section-block { box-sizing: border-box; max-width: 1100px; margin: 1.25rem auto 0; padding: 1rem 1.5rem; background: #fff; border-radius: 14px; border: 1px solid #eef2f6; box-shadow: 0 2px 8px rgba(0,0,0,.03); }
.section-title { font-size: .95rem; font-weight: 600; color: #0a2540; margin-bottom: .75rem; display: flex; align-items: center; gap: .4rem; }
.section-title i { color: #2563eb; }

/* 基本信息卡内的操作按钮行 */
.detail-actions { display: flex; flex-wrap: wrap; align-items: center; gap: .75rem; margin-top: 1.25rem; }
/* 按钮内的 Font Awesome 图标尺寸(与板块图标一致) */
.detail-actions .btn-link svg { width: 14px; height: 14px; }

/* 关联按钮 */
.btn-link { background: #2563eb; color: #fff; border: none; padding: .5rem 1.4rem; border-radius: 30px; font-weight: 500; font-size: .9rem; cursor: pointer; display: inline-flex; align-items: center; gap: .4rem; transition: background .2s; }
.btn-link:hover { background: #1d4ed8; }

.empty-state { text-align: center; padding: 3rem 1rem; color: #94a3b8; }
.empty-state i { font-size: 2.5rem; opacity: .3; margin-bottom: .5rem; }

@media (max-width: 768px) {
	.videolist-banner { height: 220px; }
	.bannertop-title { top: 48%; }
	.bannertop-title div:nth-of-type(1) { font-size: 24px; }
	.bannertop-title div:nth-of-type(2) { font-size: 14px; width: 80%; }
	.app-container { padding: 1rem .75rem; }
	.detail-card { padding: 1rem; }
	.detail-card .field { flex-direction: column; gap: .2rem; }
	.detail-card .field .label { width: auto; }
}
</style>

<style>
@import '../../assets/css/alibaba.css';
</style>